import React from "react";

import "../../Styles/careers.css";
import careersimg from "../../Assets/images/carresimg.png";
import Form from "./careerform";

const Careers = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div className="main-app-caontiner">
      <div className="careers-bg-container">
        <div className="width-wrapper">
          <div className="wraper-card-col">
            <h1>Careers</h1>
            <div className="wraper-card-row">
              <h2 data-aos="fade-right" data-aos-delay="200">
                Let's Redefine the Future of Hiring with AI
              </h2>
              <div
                className="wraper-card-row-1"
                data-aos="fade-left"
                data-aos-delay="200"
              >
                <p>
                  AI is transforming how we work — but recruitment still lags
                  behind
                </p>
                <p>
                  At Ann, we’re using advanced AI to remove bias, reduce effort,
                  and make hiring more human. We’re building tools that empower
                  employers and candidates alike — and we’re just getting
                  started.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* second section */}
      <div className="wrap-card-row-2">
        <div className="width-wrapper">
          <div className="wraper-card-row">
            <img
              src={careersimg}
              alt="alt1"
              data-aos="fade-right"
              data-aos-delay="200"
            />
            <div
              className="wraper-col-2"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <h1>What Makes Working at Ann So Unique?</h1>

              <strong>A Bold Purpose</strong>
              <p>
                We’re on a mission to help businesses hire smarter and job
                seekers land roles faster — powered by intelligent automation.
                Our goal? Reinvent recruitment for the AI era.
              </p>

              <strong>Move Fast, Learn Faster</strong>
              <p>
                You'll contribute from day one. Whether you're writing code,
                crafting UI, or planning GTM, expect to launch early and often.
              </p>

              <strong>Impact from Day One</strong>
              <p>
                Ann is growing fast — and you’ll be at the center of it. Your
                work will influence product, brand, and industry direction in
                meaningful ways.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* third section */}

      <div className="wrap-card-row-3">
        <div className="width-wrapper">
          <div className="wraper-card-col wraper-card-col-3">
            <h1>Why Join the Ann Team?</h1>
            <div className="wraper-card-row-3">
              <div
                className="wrap-card-3"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <h3>Remote, But Together:</h3>
                <p>
                  We’re remote-first, with regular virtual team hangs and
                  in-person meetups.
                </p>
              </div>
              <div className="wrap-card-3" data-aos="zoom-in-down">
                <h3>Design-Obsessed:</h3>
                <p>
                  We care deeply about great UX and clean interfaces — and we
                  back that up with action.
                </p>
              </div>
              <div
                className="wrap-card-3"
                data-aos="fade-left"
                data-aos-delay="200"
              >
                <h3>Global Reach:</h3>
                <p>
                  Ann is being used by hiring teams and job seekers across the
                  world
                </p>
              </div>
              <div
                className="wrap-card-3"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <h3>Unlimited Time Off:</h3>
                <p>
                  We trust you to take the time you need. Work-life balance is
                  built in.
                </p>
              </div>
              <div className="wrap-card-3" data-aos="zoom-in-down">
                <h3>Flexible Workstyle:</h3>
                <p>
                  Prefer async or 9-to-5? Laptop or desktop? We support your
                  best way to work..
                </p>
              </div>
              <div
                className="wrap-card-3"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <h3>Mission-Driven:</h3>
                <p>
                  Every line of code and every campaign supports a mission we
                  believe in: better, fairer hiring.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* fourth section */}
      <div className="wrap-card-rwo-4">
        <div className="width-wrapper">
          <div className="wraper-card-col wraper-card-col-4">
            <h1>Join Us at Ann</h1>
            <p>
              You don’t need to be an HR expert — just someone who believes in
              making tech more human.
            </p>
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;
